import { render } from "./AppTableRow.vue?vue&type=template&id=1d54f0e2&scoped=true"
import script from "./AppTableRow.vue?vue&type=script&lang=js"
export * from "./AppTableRow.vue?vue&type=script&lang=js"

import "./AppTableRow.vue?vue&type=style&index=0&id=1d54f0e2&lang=scss&scoped=true"

import exportComponent from "/var/www/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d54f0e2"]])

export default __exports__